import { config } from "../../../../config";
import { useGetGameTimer } from "./useGetGameTimer";

interface GameTimerProps {
  isSecondHalfPlaying?: boolean;
  startDate: string;
}

export const GameTimer = ({
  isSecondHalfPlaying,
  startDate,
}: GameTimerProps) => {
  const date = new Date(startDate);
  if (isSecondHalfPlaying) {
    date.setSeconds(date.getSeconds() - config.halftimeDuration);
  }
  const time = useGetGameTimer(date.toISOString());

  return (
    <div className="bg-red-500 rounded-full pb-1 px-3 animate-pulse">
      <span className="text-white font-bold text-xs">{time}</span>
    </div>
  );
};
